import { Card, CardContent } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { AiFillInfoCircle } from "react-icons/ai";
import Lottie from "react-lottie-player";
import { useLocation, useParams } from "react-router-dom";
import failure from "../assets/failure.json";
import succeess from "../assets/success.json";
import "./../App.css";
import brokerLogo from "./../broker-logo.png";
import { TfiNewWindow } from "react-icons/tfi";
import { payTransactionDetails } from "../Utils/constant";
import timer from "../assets/timer.svg";
import * as API from "./../Utils/Services";
import { QRCodeSVG } from "qrcode.react";

function AddFunds() {
  let location = useLocation();
  const [upiSuccess, setUPISuccess] = useState("");
  const [data, setData] = useState();
  const [seconds, setSeconds] = useState(300);
  const [isActive, setIsActive] = useState(false);
  const [qrValue, setQrValue] = useState("");
  const intervalRef = useRef(null);
  const [isRedirecting, setIsRedirecting] = useState(false);
  let postHeader = {
    UserName: localStorage.getItem("clientID"),
    Authorization: `Bearer ` + localStorage.getItem("authToken"),
    "P-Appname": "space",
  };
  useEffect(() => {
    let interval = null;
    if (seconds > 0) {
      interval = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);
    } else if (seconds === 0) {
      clearInterval(interval);
      setIsActive(false);
    }

    return () => clearInterval(interval);
  }, [isActive, seconds]);
  // Logic to format seconds into MM:SS
  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const remainingSeconds = time % 60;
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  };

  const clientId = localStorage.getItem("clientID");


  // 🔥 NEW (add these helpers at top inside component)
  const isMobile = () =>
    /android|iphone|ipad|ipod/i.test(
      (navigator.userAgent || "").toLowerCase()
    );

  const isIOS = () =>
    /iphone|ipad|ipod/i.test(
      (navigator.userAgent || "").toLowerCase()
    );

  const isAndroid = () =>
    /android/i.test(
      (navigator.userAgent || "").toLowerCase()
    );

  // 🔥 NEW
  const openUpiIntent = (upiLink) => {
    let hasOpened = false;

    const handleVisibility = () => {
      if (document.visibilityState === "hidden") {
        hasOpened = true;
        setIsRedirecting(false); // ✅ stop loader
      }
    };

    document.addEventListener("visibilitychange", handleVisibility);


    if (isIOS()) {
      // iOS fix (anchor click)
      const a = document.createElement("a");
      a.href = upiLink;
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } else {
      window.location.href = upiLink;
    }

    setTimeout(() => {
      document.removeEventListener("visibilitychange", handleVisibility);

      if (!hasOpened) {
        setIsRedirecting(false);
      }
    }, 2500);
  };
  useEffect(() => {
    const upiLink = `upi://pay?pa=${payTransactionDetails.payeeVirtualAddress}&pn=${payTransactionDetails.payeeName}&am=${location?.state?.tranData?.amount}&tn=${clientId}&tr=${location?.state?.tranData.merchantTransactionId}&cu=INR&mc=${payTransactionDetails.mcc}&mode=04`;

    setQrValue(upiLink);

    // 🔥 NEW → AUTO OPEN UPI (ONLY MOBILE)
    if (isMobile() && upiLink) {
      setIsRedirecting(true); // ✅ start loader
      setTimeout(() => {
        openUpiIntent(upiLink);
      }, 2000); // 2 sec delay after page load
    }

    // Existing polling (unchanged)
    intervalRef.current = setInterval(() => {
      fetchData();
    }, 5000);

    return () => {
      clearInterval(intervalRef.current);
    };
  }, [location?.state?.tranData?.merchantTransactionId, clientId]);
  // Function to fetch payment status
  const fetchData = () => {
    let payLoad = {
      clientId: clientId,
      customerReferenceNo: "",
      orderNo: parseInt(location?.state?.orderNo),
      orderNoString: "",
      upiTransactionId: 0
    };
    API.PostMethod("v2/hdfc/transactionStatusEnquiry",
      payLoad,
      postHeader
    )
      .then((res) => {
        const status = res?.data?.transactionStatus;
        setUPISuccess(status);
        setData(res?.data);
        if ((status === "SUCCESS" || status === "FAILED") && res?.data?.customerReferenceNumber) {
          clearInterval(intervalRef.current);
        }
      })
      .catch((err) => { });
  };

  return (
    <div className="App">
      <div className="App-header">
        <div className="d-flex pkt-height-vh-90 pkt-width-percentage-100 justify-content-center align-items-center">
          <Card className="d-flex pkt-height-percentage-100 pkt-overflow-y-auto col-12 col-sm-10 col-md-8 col-lg-6 col-xl-3 pkt-no-box-shadow">
            <CardContent className="d-flex flex-column pkt-width-percentage-100 justify-content-start align-items-center pkt-padding-25">
              {" "}
              <div className="d-flex flex-column pkt-width-percentage-100 justify-content-start align-items-center">
                <img
                  src={brokerLogo}
                  alt="logo"
                  style={{ height: "60px", width: "180px" }}
                />
                <div className="pkt-margin-top-15 pkt-font-bold pkt-font-size-22">
                  Amount Payable : ₹ {location?.state?.amount}
                </div>
                <hr
                  className="pkt-width-percentage-100"
                  style={{ borderTop: "2px dashed #5300F4" }}
                ></hr>
              </div>
              <div
                className="d-flex flex-column pkt-width-percentage-100 align-items-start"
                style={{ flex: 1 }}
              >

                <div className="pkt-width-percentage-100 pkt-min-height-100 pkt-margin-top-10">
                  <Card
                    className="pkt-margin-top-5 pkt-width-percentage-100 pkt-height-percentage-100 align-items-start justify-content-around d-flex flex-column pkt-padding-10"
                    sx={{
                      background: "rgb(255 220 184 / 97%)",
                      boxShadow: 0,
                      borderRadius: "10px",
                    }}
                  >
                    <div className="d-flex flex-row justify-content-start align-items-start">
                      {" "}
                      <div>
                        <AiFillInfoCircle></AiFillInfoCircle>
                      </div>
                      <span className="pkt-font-size-18 pkt-margin-left-8">
                        Please Pay via
                      </span>
                    </div>
                    <div
                      className="pkt-font-size-18 pkt-padding-10 pkt-font-bold pkt-margin-left-16"
                      style={{ textAlign: "start" }}
                    >
                      <span className="pkt-font-size-18  pkt-font-bold">
                        {location?.state?.bank} :{" "}
                        <span className="pkt-font-size-13">XXXXXXXXX</span>
                        {location?.state?.bankAccount.slice(-4)}
                      </span>
                    </div>
                  </Card>
                </div>{" "}
                {isRedirecting && (
                  <div style={{ marginTop: "20px", textAlign: "center", width: "100%" }}>
                    <div style={{ fontSize: "16px", fontWeight: "500" }}>
                      Redirecting to UPI app...
                    </div>
                  </div>
                )}
                <div className="d-flex justify-content-start pkt-padding-20 align-items-center pkt-width-percentage-100">
                  {" "}
                  {seconds === 0 ? (
                    <div className="d-flex flex-column pkt-width-percentage-100  align-items-center">
                      <Lottie
                        loop={false}
                        animationData={failure}
                        play
                        style={{ width: 150, height: 150 }}
                      />

                      <span
                        style={{ color: "#dc3545" }}
                        className="pkt-font-bold pkt-margin-top-20 pkt-font-size-20"
                      >
                        Timeout!
                      </span>

                      <span
                        style={{ color: "#dc3545" }}
                        className="pkt-margin-top-40 pkt-font-size-14"
                      >
                        Please close the window and try again!
                      </span>
                    </div>
                  ) : upiSuccess === "SUCCESS" ? (
                    <div className="d-flex flex-column pkt-width-percentage-100  align-items-center">
                      <Lottie
                        loop={false}
                        animationData={succeess}
                        play
                        style={{ width: 150, height: 150 }}
                      />

                      <span
                        style={{ color: "#00b7b1" }}
                        className="pkt-font-bold pkt-margin-top-10 pkt-font-size-20"
                      >
                        SUCCESS
                      </span>

                      <span
                        style={{ color: "#00b7b1" }}
                        className="pkt-margin-top-10 pkt-font-bold pkt-font-size-20"
                      >
                        Deposited Amount INR {data?.amount}
                      </span>

                      <span
                        style={{ color: "#00b7b1" }}
                        className="pkt-margin-top-20 pkt-font-size-18"
                      >
                        Reference No. : {data?.customerReferenceNumber}
                      </span>
                      <div
                        className="d-flex flex-row align-items-center pkt-margin-top-8 pkt-cursor-pointer"
                        style={{
                          borderBottom: "1px dashed ",
                          color: "#5300f4 ",
                        }}
                        onClick={() => {
                          window.location.replace(
                            "https://pacetrader.pacefin.in/funds/info"
                          );
                        }}
                      >
                        <span>Go to pace trader</span>{" "}
                        <div className="d-flex align-items-center jsutify-content-center pkt-margin-left-6">
                          {" "}
                          <TfiNewWindow />{" "}
                        </div>
                      </div>
                      <span
                        style={{ color: "#dc3545" }}
                        className="pkt-margin-top-10 pkt-font-size-14"
                      >
                        Please close the window!
                      </span>
                    </div>
                  ) : upiSuccess === "REJECTED" || upiSuccess === "FAILED" ? (
                    <div className="d-flex flex-column pkt-width-percentage-100  align-items-center">
                      <Lottie
                        loop={false}
                        animationData={failure}
                        play
                        style={{ width: 150, height: 150 }}
                      />

                      <span
                        style={{ color: "#dc3545" }}
                        className="pkt-font-bold pkt-margin-top-20 pkt-font-size-20"
                      >
                        {upiSuccess === "REJECTED"
                          ? "Payment Rejected"
                          : upiSuccess === "FAILED"
                            ? "Payment Failed"
                            : null}
                      </span>
                      <span
                        style={{ color: "rgb(19 36 191)" }}
                        className="pkt-margin-top-20 pkt-font-size-18"
                      >
                        Reference No. : {data?.customerReferenceNumber}
                      </span>
                      <div
                        className="d-flex flex-row align-items-center pkt-margin-top-20 pkt-cursor-pointer"
                        style={{
                          borderBottom: "1px dashed ",
                          color: "#5300f4 ",
                        }}
                        onClick={() => {
                          window.location.replace(
                            "https://pacetrader.pacefin.in/funds/info"
                          );
                        }}
                      >

                        <span>Go to pace trader</span>{" "}
                        <div className="d-flex align-items-center jsutify-content-center pkt-margin-left-6">
                          {" "}
                          <TfiNewWindow />{" "}
                        </div>
                      </div>
                      <span
                        style={{ color: "#dc3545" }}
                        className="pkt-margin-top-28 pkt-font-size-14"
                      >
                        Please close the window and try again!
                      </span>
                    </div>
                  ) : (
                    <div className="d-flex flex-column justify-content-center align-items-center "
                      style={{
                        border: '1px solid rgb(232, 232, 238) ',
                        padding: '20px 0px',
                        width: '100%',
                        gap: '20px'
                      }}>
                      <span
                        style={{
                          fontWeight: '500',
                          fontSize: '24px'
                        }}
                      >
                        ₹{location?.state?.amount}
                      </span>
                      {qrValue ? (
                        <QRCodeSVG
                          value={qrValue}
                          size={250}
                          className="w-[194px] h-[194px]"
                        />
                      ) : (
                        "Loading"
                      )}
                      <span
                        style={{
                          color: "rgb(154, 152, 152)",
                          fontSize: '14px', fontWeight: '400'
                        }}
                      >
                        Scan QR code to pay using any UPI app
                      </span>
                      <div className="d-flex flex-row align-items-center gap-3 bg-main-grey py-2 px-3 rounded-sm">
                        <img src={timer} alt="timer" />
                        <span>
                          <span className="text-text-color-secondary ">
                            Approve payment in
                          </span>{" "}
                          <span style={{ color: "rgb(35, 31, 32)" }}>
                            {formatTime(seconds)} mins
                          </span>
                        </span>
                      </div>
                      {isMobile() && qrValue && (
                        <a
                          href={qrValue}
                          style={{
                            marginTop: "12px",
                            color: "#5300f4",
                            textDecoration: "underline",
                            fontWeight: "500",
                            display: "inline-block",
                          }}
                        >
                          Open UPI App
                        </a>
                      )}
                    </div>
                  )}{" "}
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}


export default AddFunds;
